import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'
import {createSlice} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";
import {rootReducer} from "../store";

export const documentsTypesApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'documentsTypeApi',
  endpoints: (builder) => ({
    getDocumentTypes: builder.query<DocumentTypeItem[], string>({
      query: (query) => `certification/v4.0/documents/`,
    }),
    getDocumentTypesByCode: builder.query<DocumentsByCodeItem[], string>({
      query: (id) => `certification/v4.0/documents/${id}/`,
    }),
  }),
})

export const documentsTypesSlice = createSlice({
  name: 'documentsTypes',
  initialState: {
    documentsTypes: [] as DocumentTypeItem[],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      documentsTypesApi.endpoints.getDocumentTypes.matchFulfilled,
      (state, { payload }) => {
        state.documentsTypes = payload
      }
    );
  },
})

export const { useLazyGetDocumentTypesQuery, useLazyGetDocumentTypesByCodeQuery } = documentsTypesApi

export const useDocumentsTypes = () => {
  return useSelector(({ documentsTypes }: ReturnType<typeof rootReducer>) => documentsTypes.documentsTypes)
}
